import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Tabs, Tab, Button, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import CommentMgmt from "./comment/CommentMgmt";
import ImageGalleryHolder from "core/components/image-gallery/ImageGalaryHolder";
import { setProductSelectImageModal, setProductassetDashboardProductassetList, setAssetcommentsList, updateProductObj, setProductassetAnnotateAssetModal } from 'store/slice/PharmaSlice';
import SelectImageActionModal from "components/product/action/selectImage/SelectImageActionModal";
import { getProductassetInfoByProductidAPI } from "components/productasset/ProductassetAPI";
import { setHideTaskActionBar, setAnnotationMode } from "store/slice/AppSlice";
import { initRefreshTaskList } from "store/slice/AppSlice";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { setSelectedImage, setSelectedAssetIdList } from "store/slice/ImageGallerySlice";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { submitDesignQaApprovalAPI } from "api/OmsOrdermgmtWebServices";
import { setProductassetViewModal } from "store/slice/PharmaSlice";
import { getAssetcommentsInfoByProductidAPI } from 'components/assetcomments/AssetcommentsAPI';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { updateProductInfo } from "components/product/ProductAPI";
import { convertDateInFormat_yyyyMMdd } from "core/js/FormUtils";
import AnnotateAssetActionModal from "components/productasset/action/AnnotateAsset/AnnotateAssetActionModal";



const steps = [
  "View Asset List",
  "Upload Asset & Customer Approval",
  "Submitted for Approval"
];

export default function TaskSpaceDesignerReviseDesign() {
  const dispatch = useDispatch();
  const [confirmed, setConfirmed] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [apiError, setApiError] = useState(""); // <-- Add this line
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);

  const [customerApprovalDate, setCustomerApprovalDate] = useState(convertDateInFormat_yyyyMMdd(productObj.designapprovaldate));
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedTaskObj, taskCompleted } = useSelector((state) => state.appslice.wkflow);
  const { productassetList } = useSelector((state) => state.pharmaslice.productassetDashboard);
  const { selectedImagePath, selectedImage, selectedImageId } = useSelector((state) => state.imagegalleryslice);


  useEffect(() => {
    dispatch(setSelectedImage({ name: '', path: '' }));
    dispatch(setSelectedAssetIdList(''));
    dispatch(setHideTaskActionBar(false));

    
  }, []);
  // useEffect(() => {
  //   if (productassetList && productassetList.length === 0) {
  //     setActiveStep(1);
  //   }
  //   else {
  //     {
  //       getAssetcommentsInfoByProductidAPI(productObj.id, () => { },
  //         (response) => {
  //           dispatch(setAssetcommentsList(response))
  //         });
  //       setActiveStep(0);
  //     }
  //   }
  // }, [productassetList]);

  useEffect(() => {
    if (productObj) {
      setCustomerApprovalDate(convertDateInFormat_yyyyMMdd(productObj.designapprovaldate));

      if (productObj.assetid!==0 && productObj.assetpath !== '') {
        dispatch(setCompleteTaskButtonEnabled(true))
      } else {
        dispatch(setCompleteTaskButtonEnabled(false))
      }
    }
  }, [productObj])

  // useEffect(() => {
  //   if (productObj.designapprovaldate && confirmed && productObj.assetpath !== '') {
  //     dispatch(setCompleteTaskButtonEnabled(true))
  //   } else {
  //     dispatch(setCompleteTaskButtonEnabled(false))
  //   }
  // }, [confirmed])

  useEffect(() => {
    if (productObj && selectedImageId !== -1) {
      updateProductInfo(productObj.id,
        {
          assetid: selectedImageId,
          assetname: selectedImage,
          assetpath: selectedImagePath
        },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Failed to attach asset to product:", error);
        }
      )
    }
  }, [selectedImageId]);

  const showAsset = (imageObj) => {
    dispatch(setSelectedImage({ 'name': productObj.assetname, 'path': productObj.assetpath }));
    dispatch(setProductassetViewModal(true));

  }
  const showQAasset = () => {
    dispatch(setSelectedImage({ 'name': productObj.qaassetname, 'path': productObj.qaassetpath }));
    dispatch(setProductassetViewModal(true));

  }
  const viewAnnotatedDesign = () => {
    dispatch(setAnnotationMode("READ"))
    dispatch(setProductassetAnnotateAssetModal(true));
  }

  const updateCustomerApprovalDate = (newDate) => {
    console.log("newDate==>", newDate)
    updateProductInfo(productObj.id,
      { designapprovaldate: newDate !== '' ? newDate : null }
      , (response) => {
        dispatch(updateProductObj(response));
      }
      , (error) => {
        console.error("Error updating customer approval date:", error);
        setApiError(error);
      });
  }

  const handleDateChange = (newDate) => {
    updateCustomerApprovalDate(newDate);
  }

  return (
    <Grid container sx={{ width: '100%', }}>
      {/* Left Section: 4 columns, with Tabs */}
      <Grid item lg={4} md={4} sm={12} xs={12}>
        <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
          <Tabs
            value={tabIndex}
            onChange={(_, v) => setTabIndex(v)}
            variant="fullWidth"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="Product Info" />
            <Tab label="Comments" />
          </Tabs>
          <Box sx={{}}>
            {tabIndex === 0 && (
              <ProductInfo maxHeight="70vh" />
            )}
            {tabIndex === 1 && (
              <Box sx={{ p: 2, minHeight: '70vh' }}>
                <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                  <CommentMgmt maxHeight="60vh" status={1} />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Grid>
      {/* Right Section: 8 columns, rest of the content */}
      <Grid item lg={8} md={8} sm={12} xs={12}>
        <Grid container direction="row" sx={{ width: '100%' }}>

          <Grid item lg={6} md={4} sm={4} xs={4} sx={{ p: 1 }}>
            <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2, width: '100%', minHeight: '40vh' }}>
              <Grid container justifyContent="space-between" sx={{ width: '100%' }}>
                <Grid item lg={12}>
                  <Grid container direction="row" justifyContent="space-between" >
                    <Grid item lg={4}>
                      <Typography variant="h6" sx={{ color: 'primary.darker', }}>Reviewed Design </Typography>
                    </Grid>
                    <Grid item lg={8}>
                      <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'right' }}><i>Click on image to view design comments</i></Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {productObj.qaassetpath ?
                <>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", mt: 1 }}>
                    <img
                      onClick={() => { viewAnnotatedDesign() }}
                      src={productObj.qaassetpath}
                      alt="Product Asset"
                      style={{ borderRadius: 8, marginBottom: 16 }}
                      width="350px"
                      height="200px"
                    />
                  </Box>
                </> :
                <>
                  <Typography variant="body2" color="text.secondary">
                    No QA Asset Available
                  </Typography>
                </ >

              }
            </Box>
            {/* <Box
              sx={{
                mt: 2,
                flex: 1,
                background: "white",
                borderRadius: 2,
                p: 3,
                //boxShadow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "left",
                justifyContent: "center",
                // minHeight: 200,
                gap: 2
              }}
            >
              <TextField
                label="Customer Approval Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                sx={{ minWidth: 220 }}
                value={customerApprovalDate || ""}
                onChange={e => handleDateChange(e.target.value)}
                disabled={taskCompleted}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={confirmed}
                    onChange={e => setConfirmed(e.target.checked)}
                    color="primary"
                    disabled={taskCompleted}
                  />
                }
                label="I confirm that Customer has approved this asset on above mentioend date."
              />
            </Box> */}

          </Grid>
          <Grid item lg={6} sx={{ p: 1 }}>
            <Grid container direction="column" sx={{ width: '100%', }}>
              <Grid item lg={12} sx={{}}>
                <Box sx={{ p: 1, backgroundColor: 'white', borderRadius: 2 }}>
                  <Grid container justifyContent="space-between" sx={{}}>
                    <Grid item lg={6}>
                      <Typography variant="h6" sx={{ color: 'primary.darker', }}>Design for Review </Typography>
                    </Grid>
                    {!taskCompleted && productObj.assetpath !== '' &&
                      <Grid container justifyContent="flex-end" lg={6}>
                        <Button variant="text" size="small" onClick={() => dispatch(setProductSelectImageModal(true))}>
                          Change
                        </Button>
                      </Grid>
                    }
                  </Grid>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", mt: 1 }}>
                    {productObj.assetpath !== '' ?
                      <img
                        onClick={() => { showAsset() }}
                        src={productObj.assetpath}
                        alt="Product Asset"
                        style={{ borderRadius: 8, marginBottom: 16 }}
                        width="350px"
                        height="200px"
                      />
                      : <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", mt: 1 }}>
                        <CloudUploadIcon
                          sx={{ fontSize: 48, color: "grey.500", mb: 1 }}
                          onClick={() => dispatch(setProductSelectImageModal(true))}
                        />
                        <Typography variant="body2" color="text.secondary">
                          Upload Image
                        </Typography>
                      </Box>
                    }
                  </Box>
                </Box>
                {/* {!taskCompleted &&
                <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end", mt: 2 }}>
                  <Button variant="text" onClick={() => dispatch(setProductSelectImageModal(true))}>
                    Upload New Asset for QA Approval
                  </Button>
                </Box>} */}
              </Grid>

            </Grid>
          </Grid>

        </Grid>
      </Grid>
      <SelectImageActionModal />
      <AnnotateAssetActionModal />
    </Grid>
  );
}